(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-quick-view-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    var closeButton = event.target.closest('[data-quick-view-close]');
    if (closeButton) {
      var parentDialog = closeButton.closest('[data-quick-view]');
      if (parentDialog && parentDialog.open) parentDialog.close();
      return;
    }

    if (event.target.matches('[data-quick-view]')) event.target.close();
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-quick-view-variant]');
    if (!select) return;
    var price = select.closest('[data-quick-view]').querySelector('[data-quick-view-price]');
    var option = select.options[select.selectedIndex];
    if (price && option) price.textContent = option.dataset.price || '';
  });
}());

